import { useEffect } from 'react';

import IncomeIQueueBody from 'components/practice/Settings/components/HealthcareProgram/components/IncomeIQueueRcmTab/components/IncomeIQueueBody';
import { useIncomeIQueueDraft } from 'components/practice/Settings/components/HealthcareProgram/components/IncomeIQueueRcmTab/lib/useIncomeIQueueDraft';
import Skeleton from 'components/shared/Skeleton/Skeleton';
import Typography from 'components/shared/Typography/Typography';

const OnboardingIncomeIQueue = ({
  addFooterActions,
  mutateOrchestratorData,
  orchestratorLoading,
  orchestratorData
}) => {
  const {
    data,
    isLoading,
    isError,
    isDirty,
    isSaving,
    activeNetwork,
    activeNetworkValues,
    handleNetworkChange,
    handleScenariosChange,
    saveAsync
  } = useIncomeIQueueDraft({
    practiceId: orchestratorData?.practiceId,
    enabled: !!orchestratorData?.practiceId
  });

  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: async () => {
          if (isDirty) {
            try {
              const ok = await saveAsync();
              if (!ok) return;
            } catch {
              return;
            }
          }
          mutateOrchestratorData({});
        },
        isDisabled: orchestratorLoading || isSaving
      }
    ]);
  }, [addFooterActions, isDirty, isSaving, orchestratorLoading, saveAsync, mutateOrchestratorData]);

  if (isLoading && !data) {
    return (
      <div className="w-full p-6">
        <Skeleton count={4} height={40} containerClassName="w-full" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="w-full p-6">
        <Typography size="small" color="danger-600">
          Failed to load IncomeIQueue RCM settings.
        </Typography>
      </div>
    );
  }

  return (
    <IncomeIQueueBody
      activeNetwork={activeNetwork}
      activeNetworkValues={activeNetworkValues}
      onNetworkChange={handleNetworkChange}
      onScenariosChange={handleScenariosChange}
    />
  );
};

export default OnboardingIncomeIQueue;
